import { LocalizationMessages } from './en-us';

const FR_CA: LocalizationMessages = {
    common: {
        save: 'Enregistrer',
        edit: 'Edition',
        cancel: 'Annuler',
        delete: 'Supprimer',
        email: 'Courriel',
        addNew: 'Nouveau',
        error: 'Erreur'
    },
    locationRoot: {
        menus: {
            'CITATION SEARCH': 'Recherche de citation',
        },
    },
    locationHome: {
        jumbotron: {
            header: 'Bienvenue chez VATS'
        }
    },
    admin: {
        autoReportsMaintenance: {
            heading: 'Gestion des autoreports',
            report: 'Rapport',
            period: 'Période',
            recipients: 'Destinataires',
            actions: 'Actions',
            confirmDeleteMessage: 'Êtes-vous sûr de vouloir supprimer ce rapport?\n\nRapport: {report}\nPériode: {period}\nDestinataires: {recipients}'
        },
        myReportsManagement: {
            reportsLabel: 'Rapports pour les utilisateurs {userName} à l\'emplacement {currentLocation}',
            multiselectPlaceholder: 'Sélectionnez le(s) rapport(s)',
            multiselectSelectionLabel: '{numReports} rapport(s) sélectionné(s)'
        },
        chalkingLocationRules: {
            lotIdHeader: 'Lot',
            blockNumberHeader: 'Bloc',
            requireBlockNumberHeader: 'N° de bloc requis',
            requireSpaceNumberHeader: 'N° d\'espace requis',
            requireValveStemPositionHeader: 'Tige de vanne pos. requise',

            deleteConfirmMessage: 'Supprimer vraiment cette règle?\n\n{lot}\n{block}',
            deleteConfirmTitle: 'Confirmer Supprimer',
            deleteRuleError: 'Règle de supprimer les erreurs',
            refreshRulesError: 'Règles de rafraîchissement des erreurs'
        },
        tableManagement: {
            heading: 'Gestion des tables',
            recID: 'RecID',
            code: 'Code',
            description: 'Description',
            order: 'Ordre',
            deleteConfirmMessage: 'Êtes-vous sûr de vouloir supprimer l\'enregistrement {recID}?',
            deleteItemError: 'Erreur de suppression d\'un élément',
            errorInMethodX: 'Erreur dans la méthode {x}'
        },
    },
    message: {
        helloWorld: 'salut'
    },
    login: {
        /* tslint:disable-next-line */
        userNameLabel: "Nom d'utilisateur",
        passwordLabel: 'Mot de passe',
        submitText: 'Entrer',
        loginForbiddenTitle: 'Connexion interdite',
        loginForbiddenMessage: 'Le compte est bloqué.',
        tooManyRequestsTitle: 'Trop de demandes'
    },
    currency: {
        style: 'currency',
        currency: 'CAD'
    },
};

export default FR_CA;
